import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LastAnswerState {
	checkedAnswerIndices: number[];
}

const initialState: LastAnswerState = {
	checkedAnswerIndices: [],
};

export const lastAnswerSlice = createSlice({
	name: "lastAnswer",
	initialState,
	reducers: {
		setLastAnswer(state, action: PayloadAction<number[]>) {
			state.checkedAnswerIndices = action.payload;
		},
		resetLastAnswer(state) {
			state.checkedAnswerIndices = [];
		},
	},
});

export const { setLastAnswer, resetLastAnswer } = lastAnswerSlice.actions;
export const LastAnswerReducer = lastAnswerSlice.reducer;
